import { ChangeEvent } from 'react';

export const formatPhoneNumber = (
	event: ChangeEvent<HTMLInputElement>,
	handleInputChange: (event: ChangeEvent<HTMLInputElement>) => void
) => {
	let { value, selectionStart } = event.target;
	const oldLength = value.length;

	value = value.replace(/\D/g, '');

	if (value.length > 10) {
		value = value.slice(0, 10);
	}

	if (value.length > 3 && value.length <= 6) {
		value = `${value.slice(0, 3)} ${value.slice(3)}`;
	} else if (value.length > 6) {
		value = `${value.slice(0, 3)} ${value.slice(3, 6)} ${value.slice(6)}`;
	}

	const newLength = value.length;
	event.target.value = value;
	selectionStart = selectionStart ? selectionStart + (newLength - oldLength) : 0;
	event.target.setSelectionRange(selectionStart, selectionStart);
	handleInputChange(event);
};

export const formatPhoneNumberValue = (value: string): string => {
	if (!value) return value;

	const cleanedValue = value.replace(/\D/g, '').slice(0, 10);

	const length = cleanedValue.length;
	if (length > 6) {
		return `${cleanedValue.slice(0, 3)} ${cleanedValue.slice(3, 6)} ${cleanedValue.slice(6)}`;
	} else if (length > 3) {
		return `${cleanedValue.slice(0, 3)} ${cleanedValue.slice(3)}`;
	}

	return cleanedValue;
};
